import { createApp } from "vue";
import { i18n } from "i18n";
import vui from "vui";
import App from "App";

const el = document.getElementById("consent-dialog");

const app = createApp(App);

app.use(i18n);
app.use(vui);

app.mount(el);
